import {z} from 'zod'

const billingTypeSchema = z.enum(['hourly', 'daily', 'weekly', 'monthly', 'flat', 'per_load'])

export const customerLastRateRawSchema = z.object({
    requirement_type: z.enum(['worker', 'rental_asset']),
    type_id: z.string(),
    billing_rate: z.string(),
    billing_type: billingTypeSchema,
    job_id: z.string(),
    job_display_id: z.string(),
})

export const customerLastRateSchema = customerLastRateRawSchema.transform((raw) => ({
    requirementType: raw.requirement_type,
    typeId: raw.type_id,
    billingRate: raw.billing_rate,
    billingType: raw.billing_type,
    jobId: raw.job_id,
    jobDisplayId: raw.job_display_id,
}))

export type CustomerLastRateRaw = z.infer<typeof customerLastRateRawSchema>
export type CustomerLastRate = z.infer<typeof customerLastRateSchema>
